import React from 'react';
import SkillsSection from './SkillsSection';
import AwardsTwo from '../Awards/AwardsTwo';
import AwardsOne from '../Awards/AwardsOne';

const Skills = () => {
  return (
    <section className="awards skills sticky primary-bg">
      <div className="container">
        {/* Skills Section */}
        <SkillsSection />

        <hr />

        {/* Awards Section */}
        <AwardsOne />
      </div>
    </section>
  );
};

export default Skills;
